export const DEPARTMENT_SORT_OPTION = { key: 'DEPARTMENT', label: 'Department' };
export const PRIMARY_POD_SORT_OPTION = { key: 'PRIMARY_POD', label: 'Primary Pod' };
export const DUE_ON_SORT_OPTION = { key: 'ACTIVE_CONTENT', label: 'Due Date' };
export const OWNER_SORT_OPTION = { key: 'OWNER', label: 'Owner' };
export const STATUS_SORT_OPTION = { key: 'STATUS', label: 'Status' };
export const LAST_ACTIVITY_DATE_SORT_OPTION = {
  key: 'LAST_ACTIVITY_DATE',
  label: 'Last Activity Date',
};
export const TEXT_SORT_OPTION = { key: 'TEXT', label: 'Name' };
export const GOAL_PROGRESS_SORT_OPTION = { key: 'GOAL_PROGRESS_PERCENTAGE', label: 'Progress' };
export const TASK_TITLE_SORT_OPTION = { key: 'TEXT', label: 'Task Title' };
export const TAGS_SORT_OPTION = { key: 'TAGS', label: 'Tags' };
export const TEAM_SORT_OPTION = { key: 'NAME', label: 'Employee Name' };
export const GOAL_NAME_SORT_OPTION = { key: 'TEXT', label: 'Goal Name' };
export const GOAL_OBJECTIVE_SORT_OPTION = { key: 'TAGS', label: 'Objective' };
